import { formatProduct } from "./checkoutStarted.js";
export default function productListViewed({
  properties
}) {
  return {
    name: "view_item_list",
    properties: {
      item_list_id: properties.list_id,
      items: properties.products?.map(formatProduct)
    }
  };
}